export enum RESOURCE_TYPE {
  'images' = 1,
  'videos' = 4,
  'documents' = 5,
  'audios' = 6,
  'others' = 7,
}